
export const DB_NAME = 'gmd_db';
export const DEVICE = 'phone';
export const RELEASE_JOB_SERIAL_NUMBER = 'Release JOB';
export const TEN_MINUTES_IN_MILISECONDS = 10 * 60 * 1000;
export const LOGGEDIN_USER_STORAGE = 'gmd-user-account';
